module.exports = __webpack_public_path__ + "static/media/scott.489048f4.jpeg";